import React, { useState, useEffect } from 'react';
import useAuth from '../../../features/hooks/useAuth';
import { useSelector } from 'react-redux';
import UnivComplaintTable from '../UnivComplaintTable';
import { complaintInboxTags } from './compInboxTags'; // Import the tags for filtering
import { useGetStoreOfficesQuery } from '../../../features/storeoffices/storeofficesApiSlice';


const CompInboxTable = ({ subTabValue, handleEditclick }) => {
  const Auth = useAuth();
  const [filterProps, setFilterProps] = useState({});
  const presentOffice = useSelector(state => state.office.off);  

  // Get store offices to find which store the L2Support user is assigned to
  const { storeoffices } = useGetStoreOfficesQuery("storeOffList", {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  });

  useEffect(() => {
    if (!Auth?.id) return;

    let updatedFilterProps = {};
    let sent_to_tags_filter = [];

    sent_to_tags_filter = complaintInboxTags[subTabValue] || [];

    // Check if subTabValue is 3 (Supervisor All Complaints - view only)
    if (Number(subTabValue) === 3 && Auth.supportuser) {
      // For Supervisor All Complaints, show all complaints from supervisor's store
      updatedFilterProps = {
        perm_store: [Auth.store]
      };
    }
    // Check if subTabValue is 6 (AllComplaints for L1/L2Support)
    else if (Number(subTabValue) === 6) {
      // For All Complaints tab, show complaints where user was involved in the flow
      updatedFilterProps = {
        perm_store: Auth.supportuser? [Auth.store]: [presentOffice]
      };
    }
    else if (Number(subTabValue) === 5 && storeoffices) {
      // For L2Support - filter by store and tags, not by curr_sent_to
      // Find which store this L2Support user is assigned to
      const userStore = Object.values(storeoffices).find(
        store => store.roleUsers?.L2Support === Auth.id
      );
      
      if (userStore) {
        updatedFilterProps = {
          perm_store: [userStore.storeoffice], // Filter by store
          perm_curr_sent_to_tag: sent_to_tags_filter?.length ? sent_to_tags_filter : ["NULL"],
        };
      } else {
        // If no store found, show nothing
        updatedFilterProps = {
          perm_curr_sent_to_tag: ["NULL_NO_STORE"],
        };
      }
    }
    else {
      // For active tabs (including L1Support), show complaints currently assigned to user
      updatedFilterProps = {
        perm_curr_sent_to: [Auth.id], // Show complaints currently assigned to user
        perm_curr_sent_to_tag: sent_to_tags_filter?.length ? sent_to_tags_filter : ["NULL"],
      };
    }
  
    console.log("Updated Filter Props:", updatedFilterProps);
    setFilterProps(updatedFilterProps);

  }, [Auth?.id, subTabValue, storeoffices]);

  console.log('CompInboxTable filterProps:', filterProps);

  const columnFilter = [
    "ComplaintNo", "AssetName", "RegisteredBy", "Subject", "ComplaintCat", 
    "ComplaintFilingTime", "AssignedTo", "Status", "ViewDetail"
  ];

  // Handle the view detail functionality similar to handleEditclick
  const [rowid, setRowid] = useState('');
  const [viewDetail, setViewDetail] = useState(false);

  // When a row is clicked for viewing details, call the original handleEditclick
  useEffect(() => {
    if (viewDetail && rowid) {
      // Find the row data from the complaint
      // Since UnivComplaintTable doesn't directly pass row data, 
      // we'll need to handle this in the parent component
      handleEditclick && handleEditclick(null, { _id: rowid }, "ViewComplaint");
      setViewDetail(false);
    }
  }, [viewDetail, rowid, handleEditclick]);

  return (
    <>
      <UnivComplaintTable
        filterProps={filterProps}  
        columnFilter={columnFilter}
        setRowid={setRowid}
        setViewDetail={setViewDetail}
        viewType="inbox"
      />    
    </>
  );
};

export default CompInboxTable; 